import React, { Component, Fragment } from 'react';

import { TextField } from 'office-ui-fabric-react/lib/TextField';

import { localizable } from '../../../components/Localization';

@localizable
class IncreaseStep3 extends Component {
  render() {
    var {
      store: { buyerMessage, handleBuyerMessageChange },
      t,
    } = this.props;

    return (
      <Fragment>
        <ul className="hint">
          <li>{t('This text will appear as an additional note')}</li>
        </ul>

        <div className="control">
          <TextField
            label={t('Message')}
            multiline
            name="ag"
            value={buyerMessage}
            onChanged={handleBuyerMessageChange}
          />
        </div>
      </Fragment>
    );
  }
}

export default IncreaseStep3;



// WEBPACK FOOTER //
// ./src/app/containers/SaleWizard/Counteroffer/Step3.jsx